import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';

type UserProperties = {
  signUpAt: string;
};

export const updateUserProperties = async (userProperties: UserProperties) => {
  const {
    account: { id: organizationId },
    user: { id: userId },
  } = VSS.getWebContext();

  await fetch(`/actionable-agile/api/user-properties`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-55d-org-id': organizationId,
      'x-55d-user-id': userId,
    },
    body: JSON.stringify(userProperties),
  });
};

async function getUserProperties() {
  const {
    account: { id: organizationId },
    user: { id: userId },
  } = VSS.getWebContext();

  const response = await fetch(`/actionable-agile/api/user-properties`, {
    method: 'GET',
    headers: {
      'x-55d-org-id': organizationId,
      'x-55d-user-id': userId,
    },
  });

  const userProps = await response.json();

  const userProperties = { ...userProps };
  if (!userProps.signUpAt?.length) {
    // we only want to update the signUpAt date once
    const signUpAt = dayjs().toISOString();
    const body: UserProperties = {
      ...userProps,
      signUpAt: signUpAt,
    };

    await updateUserProperties(body);
    userProperties.signUpAt = signUpAt;
  }

  return userProperties;
}

type UseUserPropertiesOptions = {
  enabled?: boolean;
};

export const useUserProperties = (options?: UseUserPropertiesOptions) => {
  return useQuery({
    queryKey: ['user-properties'],
    queryFn: getUserProperties,
    staleTime: Infinity,
    enabled: options?.enabled ?? true, // Default to true for backward compatibility
  });
};

export default useUserProperties;
